import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
@Component({
  selector: 'app-selecao-data',
  templateUrl: './selecao-data.component.html',
})
export class SelecaoDataComponent implements OnInit {
  
  data;

  @Input() title = "Informe a data";

  @Input()
  set value(_value){
    this.data = moment(_value,"YYYY-MM-DD").toDate();
  };

  @Output() valueChange = new EventEmitter<any>();

  constructor(){
  }

  ngOnInit(){
  }

  dataChange($event){
    this.data = $event;
    this.valueChange.emit(this.data ? moment(this.data).format('YYYY-MM-DD') : "");
  }
}
